var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfParty = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 100,
  height: 100,
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 50,
  cy: 50,
  r: 50
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20 14.791)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.069 44.774 32.123 27.828l-1.88 3.086-2.058-7.023-7.526-7.527-4.257 10.473-2.37-1.304-6.604 17.612v.001l.193 5.377-2.428.582v.002L.132 62.6a1.991 1.991 0 0 0 .464 2.132 1.984 1.984 0 0 0 2.132.464l10.677-4.003.41-2.5 3.808.918 8.284-3.107v-3.098l4.335 1.473 8.033-3.012.844-2.404 3.343.832h.002l5.887-2.207c1.375-.516 1.752-2.281.718-3.315Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.462 50.296-4.187 1.571A36.27 36.27 0 0 1 29.32 36.01a36.48 36.48 0 0 1-1.135-12.118l3.938 3.937c.059 1.632.242 3.247.544 4.834a32.24 32.24 0 0 0 9.795 17.634ZM30.242 54.88l-4.335 1.625a36.32 36.32 0 0 1-7.573-9.51 36.315 36.315 0 0 1-4.303-21.462l3.209-8.556c.514-1.37 2.277-1.755 3.314-.717l.105.104c-4.064 9.169-3.577 19.27.659 27.647a32.312 32.312 0 0 0 8.924 10.869ZM17.623 59.612l-4.218 1.582a35.872 35.872 0 0 1-4.28-4.99c-1.446-2.01-2.848-4.481-3.932-7.097v-.002l2.235-5.959a31.724 31.724 0 0 0 4.567 10.188 31.92 31.92 0 0 0 5.628 6.278Z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.402 22.715a2.016 2.016 0 0 1 0-2.852c7.585-7.585 5.24-14.971 5.216-15.045a2.016 2.016 0 0 1 3.825-1.276c.133.398 3.139 9.844-6.19 19.173a2.016 2.016 0 0 1-2.851 0ZM43.673 29.927a2.016 2.016 0 0 0 2.851 0c7.586-7.586 14.972-5.24 15.046-5.216a2.016 2.016 0 0 0 1.275-3.826c-.397-.132-9.844-3.138-19.172 6.19a2.016 2.016 0 0 0 0 2.852Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F4CC54",
  cx: 51.834,
  cy: 7.016,
  r: 2.016
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F4CC54",
  cx: 28.501,
  cy: 2.016,
  r: 2.016
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#405B73",
  cx: 49.65,
  cy: 17.734,
  r: 2.016
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F4CC54",
  cx: 51.21,
  cy: 36.322,
  r: 2.016
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#405B73",
  cx: 30.589,
  cy: 14.26,
  r: 2.016
})))));
export default SvgLfParty;